import { useCallback, useEffect, useRef } from "react";
import { IS_WEB_VIEW } from "common/constants.ts";
import { isIOS } from "react-device-detect";

const useBackButtonHandler = () => {
  const listenerRef = useRef<BackButtonListener | null>(null);

  const registerBackButtonListener = useCallback(
    (listener: BackButtonListener) => {
      if (!IS_WEB_VIEW && !isIOS) return;
      if (listenerRef.current) {
        const index = backButtonListeners.indexOf(listenerRef.current);
        if (index !== -1) {
          backButtonListeners.splice(index, 1);
        }
      }

      listenerRef.current = listener;
      backButtonListeners.push(listener);

      return () => {
        const index = backButtonListeners.indexOf(listener);
        if (index !== -1) {
          backButtonListeners.splice(index, 1);
        }
        listenerRef.current = null;
      };
    },
    []
  );

  useEffect(() => {
    return () => {
      if (listenerRef.current) {
        const index = backButtonListeners.indexOf(listenerRef.current);
        if (index !== -1) {
          backButtonListeners.splice(index, 1);
        }
      }
    };
  }, []);

  return {
    registerBackButtonListener,
  };
};

export default useBackButtonHandler;

export const shouldBlockNavigation = (): boolean => {
  return [...backButtonListeners].reverse().some((listener) => listener());
};

type BackButtonListener = () => boolean;
const backButtonListeners: BackButtonListener[] = [];
